export const intervalTypes = [
  {
    value: "hours",
    label: "Hours",
  },
  {
    value: "days",
    label: "Days",
  },
  {
    value: "weeks",
    label: "Weeks",
  },
  {
    value: "months",
    label: "Months",
  },
  {
    value: "one-time",
    label: "One Time",
  },
];
